import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SupplierService from "../../Controller/SupplierController";
import SupplierContactService from "../../Controller/SupplierContactController";
import CreateSupplierContact from "./CreateSupplierContact";
import HelpSite from "../../../Common/HelpLink";
import SendEmail from "../../../Common/SendEmail";
function SupplierContactPage({ SupplierID }) {
    SupplierID = localStorage.getItem('SupplierID');

    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [SupplierList, setSupplierData] = useState([]);
    const [SupplierContactList, setSupplierContacts] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentSupplierContact, setCurrentSupplierContact] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const fetchSuppliers = async () => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const data = await SupplierService.GetAllSuppliers(redirectCallback);
            setSupplierData(data);
        } catch (error) {
            console.error('Error fetching Sites:', error);
        }
    };

    const fetchSupplierContact = async () => {
        try {
            const data = await SupplierContactService.GetAllSupplierContacts(redirectCallback, SupplierID);
            setSupplierContacts(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {
        debugger;
        if (SupplierID > 0) {
            fetchSuppliers();
            fetchSupplierContact();
        }
        else {
            setSupplierContacts([]);
        }

    }, [SupplierID]);

    const handleCreateSupplierContactClick = () => {
        fetchSuppliers();
        setCurrentSupplierContact(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (contact) => {
        fetchSuppliers();
        setCurrentSupplierContact(contact);
        setIsModalOpen(true);
    };

    const handleDeleteClick = async (ID, redirectCallback) => {
        const confirmed = window.confirm("Are you sure you want to delete this contact?");
        if (confirmed) {
            try {
                await SupplierContactService.DeleteSupplierContact(redirectCallback, ID);
                fetchSupplierContact(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Contact:', error);
            }
        }
    };
    const handleSuccess = () => {
        fetchSupplierContact(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const HelpLink = localStorage.getItem('HelpLink');
    const handleEmailClick = async (event, email) => {
        event.stopPropagation();
        setEmail(email)
        setIsEmailModalOpen(true);
    };
    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
    };
    return (
        <div>
             <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateSupplierContactClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className="">
                        <table className="table m-0 table-hover">
                            <thead>
                                <tr>
                                    <th>Contact Name</th>
                                    <th>Email</th>
                                    <th>Occupation</th>
                                    <th style={{ "textAlign": "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {SupplierContactList.map((contact) => (
                                    <tr key={contact.PK_SupplierContact_ID} onClick={localStorage.getItem('LicenseExpired') == "0" ? () => handleEditClick(contact) : undefined}>

                                        <td>{contact.vc_Title} {contact.vc_FirstName} {contact.vc_SurName} </td>

                                        <td>

                                            <a href='#' onClick={(event) => handleEmailClick(event, contact.vc_Email)}>
                                                {contact.vc_Email}
                                            </a>

                                        </td>
                                        <td>{contact.vc_Occupation}</td>
                                        <td className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "textAlign": "right" }}>

                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={() => handleDeleteClick(contact.PK_SupplierContact_ID)}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {isEmailModalOpen && (
                    <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} />
                )}
            </div>
            {isModalOpen && (
                <CreateSupplierContact
                    modalInstance={modalInstance}
                    currentSupplierContact={currentSupplierContact}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    SupplierList={SupplierList}
                    SupplierID={SupplierID}
                />
            )}
        </div>
    );
}

export default SupplierContactPage;
